import {
  Card,
  CardHeader,
  CardMedia,
  Collapse,
  Divider,
  Grid,
  Icon,
  Paper,
  Tab,
  Tabs,
} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Search from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps } from "../../redux/profiling/info";
import AvatarDefault from "./../../assets/profile-icon.png";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  card: {
    maxWidth: "100%",
    borderRadius: 0,
    marginBottom: theme.spacing.unit * 3,
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  avatar: {
    width: 150,
    height: 150,
    borderWidth: 1,
    backgroundColor: "#fff",
  },
  avatarHeader: {
    borderWidth: 1,
    backgroundColor: "#fff",
  },
  button: {
    margin: 10,
    padding: 0,
    display: "contents",
    boxShadow:
      "0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);",
  },
  margin: {
    marginTop: 10,
  },

  formLabel: {
    fontSize: 20,
    marginBottom: 20,
  },
});

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class ProfilingInfo extends Component {
  state = {
    phone: "",
    value: 0,
    expanded: false,
  };

  handleChangeTab = (event, value) => {
    this.setState({ value });
  };

  handleExpandClick = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  async componentDidMount() {
    await this.itemInit();
    this.history = globalHistory();
  }

  itemInit() {
    this.props.getProfilingInfo(this.state.phone);
  }

  handleSubmit = () => {
    this.itemInit();
  };

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  render() {
    const { classes, listProfiling, loading, theme } = this.props;
    const { phone, value } = this.state;
    const data =
      !(typeof listProfiling === "number") && !Object.keys(listProfiling).length
        ? true
        : false;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <Grid container style={{ justifyContent: "center" }}>
              <Grid item>
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Số điện thoại"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChange("phone")}
                  value={phone}
                  name="phone"
                  validators={["required"]}
                  errorMessages="Không được để trống"
                />
              </Grid>
              <Grid item>
                <Fab
                  color="secondary"
                  aria-label="Search"
                  className={classes.fab}
                  type="submit">
                  <Search />
                </Fab>
              </Grid>
            </Grid>
          </Card>
        </ValidatorForm>
        {!data ? (
          <React.Fragment>
            <Grid container className={classes.margin}>
              <Grid item md={4} style={{ paddingRight: 10 }}>
                <Card className={classes.card}>
                  <CardContent style={{ textAlign: "center" }}>
                    <IconButton className={classes.button}>
                      <Avatar
                        alt="avatart"
                        src={listProfiling.info.avatar}
                        className={classes.avatar}
                      />
                    </IconButton>

                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      noWrap
                      style={{ marginTop: 15 }}>
                      {listProfiling.info.name}
                    </Typography>
                  </CardContent>
                </Card>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={
                      <Avatar
                        alt="avatart"
                        src={AvatarDefault}
                        className={classes.avatarHeader}
                      />
                    }
                    title={
                      <Typography gutterBottom variant="h5" component="h3">
                        {" "}
                        Giới thiệu
                      </Typography>
                    }
                  />
                  <CardContent style={{ textAlign: "center" }}>
                    <Icon style={{ marginBottom: 10 }}>question_answer</Icon>
                    <Typography component="h4">
                      {listProfiling.info.quotes}
                    </Typography>
                  </CardContent>
                  <Divider />
                  <CardContent>
                    {listProfiling.info.info.work.map((item, key) => {
                      return (
                        <Grid
                          container
                          style={{
                            alignItems: "center",
                            whiteSpace: "normal",
                            marginTop: 10,
                          }}
                          key={key}>
                          <Grid item style={{ marginRight: 5 }}>
                            <Icon>business_center</Icon>
                          </Grid>
                          <Grid item>
                            <Typography component="h4">
                              Từng làm {item.info} tại {item.name}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    })}
                    {listProfiling.info.info.education.map((item, key) => {
                      return (
                        <Grid
                          container
                          style={{
                            alignItems: "center",
                            whiteSpace: "normal",
                            marginTop: 10,
                          }}
                          key={key}>
                          <Grid item style={{ marginRight: 5 }}>
                            <Icon>school</Icon>
                          </Grid>
                          <Grid item>
                            <Typography component="h4">
                              Từng học tại {item.name} {item.type}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    })}
                    {listProfiling.info.info.places.map((item, key) => {
                      if (item.info == "Hometown") {
                        return (
                          <Grid
                            container
                            style={{
                              alignItems: "center",
                              whiteSpace: "normal",
                              marginTop: 10,
                            }}
                            key={key}>
                            <Grid item style={{ marginRight: 5 }}>
                              <Icon>location_on</Icon>
                            </Grid>
                            <Grid item>
                              <Typography component="h4">
                                Sống tại {item.name} {item.type}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      }
                    })}
                    {listProfiling.info.info.relationship.map((item, key) => {
                      return (
                        <Grid
                          container
                          style={{
                            alignItems: "center",
                            whiteSpace: "normal",
                            marginTop: 10,
                          }}
                          key={key}>
                          <Grid item style={{ marginRight: 5 }}>
                            <Icon>loyalty</Icon>
                          </Grid>
                          <Grid item>
                            <Typography component="h4">{item.value}</Typography>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={8}>
                <Paper style={{ marginBottom: 10 }}>
                  <Tabs
                    value={value}
                    onChange={this.handleChangeTab}
                    indicatorColor="primary"
                    textColor="primary">
                    <Tab label="Dòng thời gian" />
                    <Tab label={`Bạn bè (${listProfiling.friends.length})`} />
                    <Tab label={`Nhóm (${listProfiling.groups.length})`} />
                    <Tab label={`Yêu thích (${listProfiling.likes.length})`} />
                  </Tabs>
                </Paper>
                {value === 0 && (
                  <TabContainer>
                    {listProfiling.feed
                      ? listProfiling.feed.map((item, key) => {
                          return (
                            <Card className={classes.card} key={key}>
                              <CardHeader
                                avatar={
                                  <Avatar
                                    aria-label="avatar"
                                    className={classes.AvatarDefault}
                                    src={item.from ? item.from.avatar_xs : null}
                                  />
                                }
                                title={item.from ? item.from.name : null}
                                // subheader={datetimeHelper.toFormat(item.time, "DD-MM-YYYY HH:mm:ss")}
                                subheader={datetimeHelper.timestampToDate(
                                  item.time
                                )}
                              />
                              {!!item.photos != 0
                                ? item.photos.map((i, key) => {
                                    return (
                                      <CardMedia
                                        className={classes.media}
                                        image={i.src_md}
                                        key={key}
                                      />
                                    );
                                  })
                                : null}

                              <CardContent>
                                {item.from ? (
                                  <Typography component="p">
                                    {item.text}
                                  </Typography>
                                ) : null}
                              </CardContent>
                              <CardActions
                                className={classes.actions}
                                disableActionSpacing>
                                <p
                                  style={{
                                    alignItems: "center",
                                    display: "flex",
                                    marginRight: 15,
                                  }}>
                                  <Icon style={{ marginRight: 10 }}>
                                    favorite_border
                                  </Icon>
                                  {item.num_like !== null ? item.num_like : 0}{" "}
                                  lượt thích
                                </p>
                                <p
                                  style={{
                                    alignItems: "center",
                                    display: "flex",
                                    marginRight: 15,
                                  }}>
                                  <Icon style={{ marginRight: 10 }}>reply</Icon>
                                  {item.num_share !== null
                                    ? item.num_share
                                    : 0}{" "}
                                  lượt chia sẻ
                                </p>
                                <p
                                  style={{
                                    alignItems: "center",
                                    display: "flex",
                                    marginRight: 15,
                                  }}
                                  onClick={this.handleExpandClick}>
                                  <Icon style={{ marginRight: 10 }}>forum</Icon>
                                  Bình luận
                                </p>
                              </CardActions>
                              <Divider />
                              <Collapse
                                in={this.state.expanded}
                                timeout="auto"
                                unmountOnExit>
                                <CardContent></CardContent>
                              </Collapse>
                            </Card>
                          );
                        })
                      : null}
                  </TabContainer>
                )}
                {value === 1 && (
                  <TabContainer>
                    <Paper>
                      <List className={classes.root}>
                        {listProfiling.friends
                          ? listProfiling.friends.map((item, key) => {
                              return (
                                <React.Fragment key={key}>
                                  <a
                                    href={`${item.url}`}
                                    style={{ textDecoration: "none" }}
                                    target="_blank"
                                    rel="noreferrer">
                                    <ListItem alignItems="center">
                                      <ListItemAvatar>
                                        <Avatar
                                          alt="avatar"
                                          src={item.avatar}
                                        />
                                      </ListItemAvatar>
                                      <ListItemText primary={item.name} />
                                    </ListItem>
                                  </a>
                                  <Divider />
                                </React.Fragment>
                              );
                            })
                          : null}
                      </List>
                    </Paper>
                  </TabContainer>
                )}
                {value === 2 && (
                  <TabContainer>
                    <Paper>
                      <List className={classes.root}>
                        {listProfiling.groups
                          ? listProfiling.groups.map((item, key) => {
                              return (
                                <React.Fragment key={key}>
                                  <a
                                    href={`${item.url}`}
                                    style={{ textDecoration: "none" }}
                                    target="_blank"
                                    rel="noreferrer">
                                    <ListItem alignItems="center">
                                      <ListItemAvatar>
                                        <Avatar alt="avatar" src={item.cover} />
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={item.name}
                                        secondary={
                                          item.description
                                            ? `${item.description.slice(
                                                0,
                                                50
                                              )} ...`
                                            : null
                                        }
                                      />
                                    </ListItem>
                                  </a>
                                  <Divider />
                                </React.Fragment>
                              );
                            })
                          : null}
                      </List>
                    </Paper>
                  </TabContainer>
                )}
                {value === 3 && (
                  <TabContainer>
                    <Paper>
                      <List className={classes.root}>
                        {listProfiling.likes
                          ? listProfiling.likes.map((item, key) => {
                              return (
                                <React.Fragment key={key}>
                                  <a
                                    href={`${item.url}`}
                                    style={{ textDecoration: "none" }}
                                    target="_blank"
                                    rel="noreferrer">
                                    <ListItem alignItems="center">
                                      <ListItemAvatar>
                                        <Avatar
                                          alt="avatar"
                                          src={item.avatar}
                                        />
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={item.name}
                                        secondary={item.category}
                                      />
                                    </ListItem>
                                  </a>
                                  <Divider />
                                </React.Fragment>
                              );
                            })
                          : null}
                      </List>
                    </Paper>
                  </TabContainer>
                )}
              </Grid>
            </Grid>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

ProfilingInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listProfiling: state.profilingInfo.profilingInfo,
  loading: state.profilingInfo.loading,
});

ProfilingInfo = connect(mapStateToProps, mapActionsToProps)(ProfilingInfo);

export default withStyles(styles, { withTheme: true })(ProfilingInfo);
